export enum PartnerQuestionKeys {
  SIGNUP_GOALS = 'SIGNUP_GOALS',
  RUN_PAYROLL_FOR_CLIENTS = 'RUN_PAYROLL_FOR_CLIENTS',
  OFFER_ADVISORY_SERVICES = 'OFFER_ADVISORY_SERVICES',
  PERK_GOALS = 'PERK_GOALS',
}

export enum SignUpGoalsValues {
  ADD_NEW_CLIENT = 'add_new_client',
  BECOME_PEOPLE_ADVISORY_CERTIFIED = 'become_people_advisory_certified',
  ACCESS_EXISTING_CLIENT = 'access_exisiting_client',
}

export enum PerkGoalsValues {
  FREE_PAYROLL = 'free_payroll_for_firm',
  PD_FEATURE = 'partner_directory_feature',
  REV_SHARE_OR_DISCOUNTS = 'revenue_share_or_discounts',
  PEOPLE_ADVISORY_CERTIFICATION = 'people_advisory_certification',
}

export enum YesNoValues {
  YES = 'true',
  NO = 'false',
}

export type PartnerQuestionType = {
  signupGoals?: [SignUpGoalsValues];
  runPayrollForClients?: YesNoValues;
  offerAdvisoryServices?: YesNoValues;
  perkGoals?: [PerkGoalsValues];
};

/* eslint-disable camelcase */

export type AccountantLead = {
  first_name?: string;
  last_name?: string;
  email?: string;
  accounting_firm_name?: string;
};

export type AccountantLeadFormDetails = {
  accountant_lead: {
    first_name: string;
    last_name: string;
    email: string;
    accounting_firm_name: string;
    website: string;
    number_companies_bucket: string;
    number_payroll_services_clients_bucket: string;
    phone: string;
  };
  terms_acceptance: boolean;
};

export type AccountantLeadPayload = {
  first_name: string;
  last_name: string;
  email: string;
  accounting_firm_name: string;
  website?: string;
  number_companies_bucket: string;
  phone: string;
  signup_goals: string;
  run_payroll_for_clients: string;
  offer_advisory_services: string;
  perk_goals: string;
};
